/* script page for standalone code. will not be dependent and related to bundles.js or the color and custom selectors */
jQuery(document).ready(function ($) {
  // #region hide promo code
  function hideFlowPromo() {
    $(".groupsell-wrap .groupsell-promo:has(.promo-pop-code.flow)").addClass(
      "hide",
    );
  }
  function hideRhythmPromo() {
    $(".groupsell-wrap .groupsell-promo:has(.promo-pop-code.rhythm)").addClass(
      "hide",
    );
  }
  function hideRipplePromo() {
    $(".groupsell-wrap .groupsell-promo:has(.promo-pop-code.ripple)").addClass(
      "hide",
    );
  }
  function hideSymphonyPromo() {
    $(
      ".groupsell-wrap .groupsell-promo:has(.promo-pop-code.symphony)",
    ).addClass("hide");
  }
  // #endregion

  // #region rename promo code
  function renameRhythmCode(code) {
    $(".groupsell-wrap .promo-pop-code.rhythm").text(code);
  }
  function renameRippleCode(code) {
    $(".groupsell-wrap .promo-pop-code.ripple").text(code);
  }
  function renameSymphonyCode(code) {
    $(".groupsell-wrap .promo-pop-code.symphony").text(code);
  }
  // #endregion

  // #region display price as free
  function freeRhythm() {
    $(".groupsell-wrap .voucher-wrap.rhythm .voucher-price").text("FREE");
  }
  function freeRipple() {
    $(".groupsell-wrap .voucher-wrap.ripple .voucher-price").text("FREE");
  }
  function freeSymphony() {
    $(".groupsell-wrap .voucher-wrap.symphony .voucher-price").text("FREE");
  }
  // #endregion

  // #region display grab promo
  function showGrabRhythm(code) {
    $(
      ".groupsell-wrap .groupsell-promo:has(.promo-pop-code-grab.rhythm)",
    ).removeClass("hide");
    $(".groupsell-wrap .promo-pop-code-grab.rhythm").text(code);
  }
  function showGrabRipple(code) {
    $(
      ".groupsell-wrap .groupsell-promo:has(.promo-pop-code-grab.ripple)",
    ).removeClass("hide");
    $(".groupsell-wrap .promo-pop-code-grab.ripple").text(code);
  }
  function showGrabSymphony(code) {
    $(
      ".groupsell-wrap .groupsell-promo:has(.promo-pop-code-grab.symphony)",
    ).removeClass("hide");
    $(".groupsell-wrap .promo-pop-code-grab.symphony").text(code);
  }
  // #endregion

  // #region display pre-order
  /**
   * @param {"rhythm"|"ripple"|"symphony"} type
   */
  function showPreorder(type, text = "Pre-order") {
    const textElement = document.createElement("p");
    textElement.style.margin = "0";
    textElement.innerText = text;
    const groupsellpromo = $(
      `.groupsell-wrap .groupsell-promo:has(.promo-pop-code.${type})`,
    );
    if (groupsellpromo.length) groupsellpromo[0].before(textElement);
  }
  // #endregion

  if (window.location.href.indexOf("q55u-q55-ultra-qled-google-tv") > -1) {
    hideRhythmPromo();
    hideRipplePromo();
    hideSymphonyPromo();
  } else if (
    window.location.href.indexOf("q65u-q65-ultra-qled-google-tv") > -1
  ) {
    hideFlowPromo();
    hideRhythmPromo();
    hideSymphonyPromo();
  } else if (
    window.location.href.indexOf("q75u-q75-ultra-qled-google-tv") > -1
  ) {
    hideFlowPromo();
    hideRhythmPromo();
    hideSymphonyPromo();
    $(".groupsell-wrap .promo-pop-code.ripple").text("ITSQ75URIPPLE");
  } else if (
    window.location.href.indexOf("q86-ultra-qled-google-tv") > -1 ||
    window.location.href.indexOf("prism-q100-ultra-qled-google-tv") > -1
  ) {
  } else if (window.location.href.indexOf("prism-55al-google-tv") > -1) {
  } else if (window.location.href.indexOf("al65-oled-google-tv") > -1) {
  } else if (window.location.href.indexOf("prism-77al-google-tv") > -1) {
    hideFlowPromo();
    hideRhythmPromo();
    hideRipplePromo();
  } else if (window.location.href.indexOf("q43qe-a-q43qe-google-tv") > -1) {
    hideFlowPromo();
    hideRhythmPromo();
    hideRipplePromo();
    hideSymphonyPromo();
  } else if (window.location.href.indexOf("q55qe-a-q55qe-google-tv") > -1) {
    hideFlowPromo();
    hideRhythmPromo();
    hideRipplePromo();
    hideSymphonyPromo();
  } else if (window.location.href.indexOf("q65qe-a-q65qe-google-tv") > -1) {
    hideFlowPromo();
    hideRhythmPromo();
    hideRipplePromo();
    hideSymphonyPromo();
  } else if (
    window.location.href.indexOf("prism-55al-outlet") > -1 ||
    window.location.href.indexOf("prism-s40-google-tv") > -1 ||
    window.location.href.indexOf("prism-s43-google-tv") > -1 ||
    window.location.href.indexOf("prism-q55") > -1 ||
    window.location.href.indexOf("q32c-q32-google-tv") > -1
  ) {
    hideFlowPromo();
    hideFlowPromo();
    hideRipplePromo();
    hideSymphonyPromo();
    hideRhythmPromo();
  } else if (window.location.href.indexOf("prism-q75") > -1) {
    hideFlowPromo();
    hideRhythmPromo();
    hideRipplePromo();
    hideSymphonyPromo();
  }
  $(".pdp-switch li").click(function () {
    var clickedType = $(this).attr("data-type");
    $(".pdp-toggleremote").removeClass("active");
    $(".pdp-toggle" + clickedType).addClass("active");
  });
});

/* fix to change groupsell header */
function fixAddOnText() {
  const selectors = [
    ".groupsell-wrap-second h3",
    ".groupsell-wrap.groupsell-one.single-groupsell h3 b",
    ".addon_by_variants-container h3.title",
    ".addon-section b",
    ".addon-accessories-container.variant-selector-add-on h3.title",
  ];

  document.querySelectorAll(selectors.join(",")).forEach(function (el) {
    if (el.innerHTML.match(/Add[\s-]On/i)) {
      el.innerHTML = el.innerHTML.replace(/Add[\s-]On/gi, "Add-on");
    }
  });
}

fixAddOnText();

/* fix google tv soundbar upsell header */
function fixGoogleTVSoundbarUpsell() {
  if (!document.querySelector(".template-product.google-tv")) return;

  document
    .querySelectorAll(".groupsell-wrap.groupsell-one h3")
    .forEach(function (el) {
      el.innerHTML =
        "Add-on:<span class='select-option'>Dolby Atmos Soundbar</span>";
    });
}

fixGoogleTVSoundbarUpsell();

/* SENTINEL AND SENTRY ADDON */
if (
  location.pathname === "/collections/locks/products/prism-sentinel-series" ||
  location.pathname === "/collections/locks/products/prism-sentry-series"
) {
  const TOPUP_MAP = {
    // SENTINEL PRO MAIN
    "sentinel-pro-nickel-silver": {
      "sentry-nickel-silver": 100,
      "sentry-copper-rose": 80,
      "sentry-space-grey": 100,
      "sentry-pro-space-grey": 200,
      "sentry-pro-copper-rose": 180,
    },

    "sentinel-pro-copper-rose": {
      "sentry-nickel-silver": 110,
      "sentry-copper-rose": 90,
      "sentry-space-grey": 130,
      "sentry-pro-space-grey": 210,
      "sentry-pro-copper-rose": 190,
    },

    // SENTRY MAIN
    "sentry-nickel-silver": {
      "sentinel-pro-nickel-silver": 400,
      "sentinel-pro-copper-rose": 380,
    },

    "sentry-copper-rose": {
      "sentinel-pro-nickel-silver": 380,
      "sentinel-pro-copper-rose": 360,
    },

    "sentry-space-grey": {
      "sentinel-pro-nickel-silver": 400,
      "sentinel-pro-copper-rose": 400,
    },

    "sentry-pro-space-grey": {
      "sentinel-pro-nickel-silver": 440,
      "sentinel-pro-copper-rose": 420,
    },

    "sentry-pro-copper-rose": {
      "sentinel-pro-nickel-silver": 420,
      "sentinel-pro-copper-rose": 400,
    },
  };

  function cleanVariantKey(className) {
    const cls = className
      .split(" ")
      .find((c) => c.startsWith("variant-") && c !== "variant-item");

    if (!cls) return "";

    return cls
      .replace("variant-", "")
      .replace("-eol", "")
      .replace("-bundle", "");
  }

  function updateAllTopups() {
    // Main product color
    const mainKey = cleanVariantKey(
      $(".variant-select.active")
        .find(".colorbox-select .variant-item.active")
        .attr("class") || "",
    );

    if (!mainKey) return;

    //console.log("MAIN =", mainKey);

    $(".newsalebox2").each(function (i) {
      const $card = $(this);

      const addonKey = cleanVariantKey(
        $card.find(".colorbox-select2 .variant-item.active").attr("class") ||
          "",
      );

      if (!addonKey) return;

      const topup = TOPUP_MAP[mainKey]?.[addonKey];

      /*
            console.log(
                "CARD", i,
                "| ADDON =", addonKey,
                "| TOPUP =", topup
            );
            */

      if (topup !== undefined) {
        $card.find(".prodprice2 .redtext").text("$" + topup);
      }
    });
  }

  // Initial load
  setTimeout(updateAllTopups, 100);

  // Main model switch
  $(document).on("click.topup", ".product-selector .box-title", function () {
    setTimeout(updateAllTopups, 100);
  });

  // Main color switch
  $(document).on("click.topup", ".colorbox-select .variant-item", function () {
    setTimeout(updateAllTopups, 100);
  });

  // Addon color switch
  $(document).on("click.topup", ".colorbox-select2 .variant-item", function () {
    setTimeout(updateAllTopups, 100);
  });

  // Mutation observer in case active classes are changed by script
  const observer = new MutationObserver(function () {
    updateAllTopups();
  });

  $(".variant-select, .newsalebox2 .colorbox-select2").each(function () {
    observer.observe(this, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  });
}

jQuery(window).on("load", function () {
  if (
    window.location.pathname === "/collections/vacuum/products/prism-evohub" || window.location.pathname === "/products/prism-evohub"
  ) {
    $(".grid__item.product-single__thumbnails-items.evohub-elite-thumb").hide();
      $(".grid__item.product-single__thumbnails-items.evohub-thumb").show();
    $(".box-title.prism-evohub").trigger("click");
    $(document).on("click", ".box-title.evohub", function () {
      $(".grid__item.product-single__thumbnails-items.main.evohub-thumb a").addClass('active-thumb');
      $(".grid__item.product-single__thumbnails-items.evohub-elite-thumb").hide();
      $(".grid__item.product-single__thumbnails-items.evohub-thumb").show();
      updateThumbnail();
      console.log('evohub clicked');
      
    }); 
    $(document).on("click", ".box-title.evohub-elite", function () {
      $(".grid__item.product-single__thumbnails-items.main.evohub-elite-thumb a").addClass('active-thumb');
      $(".grid__item.product-single__thumbnails-items.evohub-elite-thumb").show();
      $(".grid__item.product-single__thumbnails-items.evohub-thumb").hide();
      updateThumbnail();
      console.log('evohub-elite clicked');
    });
  }

  /* SET INITIAL VALUES */
  $(
    "#prism-sentinel-8662946513123 .variant-sentinel-pro-nickel-silver",
  ).click(); //sentinel

  $("#prism-sentry-8662946742499 .variant-sentry-nickel-silver").click(); //sentry

  //evohub
  $(".prism-evohub").click();
});
